/**
 * <recruit-hubspot-form> — loads the official HubSpot v2 embed once and
 * renders the form for this instance into its target div.
 *
 * Data attributes:
 *   data-portal  HubSpot portal ID
 *   data-region  HubSpot region (e.g. na1)
 *   data-form    HubSpot form ID
 *   data-target  id of the inner div where the form is injected
 */
const HS_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/v2.js';

class RecruitHubspotForm extends HTMLElement {
  connectedCallback() {
    this.portalId = this.dataset.portal;
    this.region = this.dataset.region || 'na1';
    this.formId = this.dataset.form;
    this.targetId = this.dataset.target;

    if (!this.portalId || !this.formId || !this.targetId) {
      console.warn('recruit-hubspot-form: missing portal, form or target.');
      return;
    }

    this.loadScript()
      .then(() => this.renderForm())
      .catch(() => console.error('recruit-hubspot-form: HubSpot script failed to load.'));
  }

  loadScript() {
    if (window.hbspt) {
      return Promise.resolve();
    }
    if (!window.__recruitHsLoader) {
      window.__recruitHsLoader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = HS_SCRIPT_SRC;
        script.charset = 'utf-8';
        script.async = true;
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', () => reject());
        document.head.appendChild(script);
      });
    }
    return window.__recruitHsLoader;
  }

  renderForm() {
    if (!window.hbspt || !window.hbspt.forms) {
      return;
    }
    window.hbspt.forms.create({
      region: this.region,
      portalId: this.portalId,
      formId: this.formId,
      target: '#' + this.targetId,
    });
  }
}

if (!customElements.get('recruit-hubspot-form')) {
  customElements.define('recruit-hubspot-form', RecruitHubspotForm);
}
